/**
 * Obtiene la extensión de archivo a partir del MIME type de un blob
 * Útil para descargas desde Cloudinary donde el nombre no incluye extensión
 * 
 * @param blob - Blob de la imagen descargada
 * @returns Extensión del archivo incluyendo el punto (ej: '.png', '.jpg')
 */
export const getExtensionFromBlob = (blob: Blob): string => {
  const mimeType = blob.type;

  if (mimeType === 'image/png') {
    return '.png';
  } else if (mimeType === 'image/jpeg' || mimeType === 'image/jpg') {
    return '.jpg';
  } else if (mimeType === 'image/webp') {
    return '.webp';
  } else if (mimeType === 'image/gif') {
    return '.gif';
  } else if (mimeType === 'image/svg+xml') {
    return '.svg';
  } else if (mimeType === 'image/bmp') {
    return '.bmp';
  }

  // Fallback por defecto
  return '.jpg';
};

